module.exports = __webpack_public_path__ + "img/MA.4fc23520.png";